<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records cart-section Medicine-cart">
            <div class="row h-100">
                <div class="col-12 mb-4">
                    <div class="bg-white border-radius-5 p-4">
                        <div class="card border-0">
                            <div class="card-body p-0">
                                <div class="d-flex justify-content-between align-items-center">
                                    <h2>Your list of Medication</h2>
                                    <a href="#"><i class="icon icon-plus"></i>Add More Medicine</a>
                                </div>
                                <div class="table-responsive">
                                    <table class="table cart-table" border="0" cellspacing="0" cellpadding="0">
                                        <thead>
                                            <tr>
                                                <th>Medicine Name</th>
                                                <th>Dosage</th>
                                                <th>Duration</th>
                                                <th>&nbsp;</th>
                                                <th>Price</th>
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td><span>1. Ceruvin 75</span></td>
                                                <td>2 times(Morning and Evening )</td>
                                                <td>10 Days, Total Tablet : 10</td>
                                                <td>
                                                    <div class="qty">
                                                        <span class="plus">-</span>
                                                        <input type="text" name="text" placeholder="2" />
                                                        <span class="plus">+</span>
                                                    </div>
                                                </td>
                                                <td><span class="green">Rs.109.27</span></td>
                                                <td><i class="icon icon-close"></i></td>
                                            </tr>
                                            <tr>
                                                <td><span>2. Azulix O MF Forte </span></td>
                                                <td>1 Time (Morning before brekfast)</td>
                                                <td>10 Days, Total Tablet : 10</td>
                                                <td>
                                                    <div class="qty">
                                                        <span class="plus">-</span>
                                                        <input type="text" name="text" placeholder="2" />
                                                        <span class="plus">+</span>
                                                    </div>
                                                </td>
                                                <td><span class="green">Rs.109.27</span></td>
                                                <td><i class="icon icon-close"></i></td>
                                            </tr>
                                            <tr>
                                                <td><span>3. Neksium 40</span></td>
                                                <td>1 Time (Before Lunch)</td>
                                                <td>10 Days, Total Tablet : 10</td>
                                                <td>
                                                    <div class="qty">
                                                        <span class="plus">-</span>
                                                        <input type="text" name="text" placeholder="2" />
                                                        <span class="plus">+</span>
                                                    </div>
                                                </td>
                                                <td><span class="green">Rs.109.27</span></td>
                                                <td><i class="icon icon-close"></i></td>
                                            </tr>
                                            <tr>
                                                <td><span>4. Tazloc-20, </span></td>
                                                <td>2 times(Morning and Evening )</td>
                                                <td>10 Days, Total Tablet : 10</td>
                                                <td>
                                                    <div class="qty">
                                                        <span class="plus">-</span>
                                                        <input type="text" name="text" placeholder="2" />
                                                        <span class="plus">+</span>
                                                    </div>
                                                </td>
                                                <td><span class="green">Rs.109.27</span></td>
                                                <td><i class="icon icon-close"></i></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="row justify-content-between Order-Summary mt-5">
                                    <div class="col-md-5 coupon">
                                        <h3>Coupon</h3>
                                        <form class="form coupon-code position-relative border-radius-8 px-3 py-2 bg-body align-items-center justify-content-between d-flex">
                                            <input type="text" name="text" placeholder="Enter your coupon code" />
                                            <button type="text" class="btn btn-blue apply">Apply</button>
                                        </form>
                                    </div>
                                    <div class="col-md-4">
                                        <h3>Order Summary</h3>
                                        <ul class="cart-table mb-0 bg-body border-radius-8">
                                            <li class="d-flex justify-content-between border-bottom">
                                                <p class="mb-0">Complete</p>
                                                <p class="mb-0">$45.00</p>
                                            </li>
                                            <li class="d-flex justify-content-between border-bottom">
                                                <p class="mb-0">Discount</p>
                                                <p class="mb-0">-$10.00</p>
                                            </li>
                                            <li class="d-flex justify-content-between">
                                                <p class="mb-0">Total</p>
                                                <p class="mb-0">$35.00</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end mt-4 mb-4 w-100 Place-Order">
                                    <div class="col-md-4 pr-0">
                                        <form class="radio-box checkbox d-flex justify-content-center mb-4">
                                            <div class="form-group m-0">
                                                <input type="checkbox" id="html" />
                                                <label class="mb-0" for="html">Note : Please select if you want to order these medicine for 3 month</label>
                                            </div>
                                        </form>
                                        <router-link to="/prescription-order-confirm" class="btn btn-blue Proceed-checkout w-100">Proceed to checkout</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Page Wrapper -->
</template>
<script>
    export default {
        name: "prescription-medicine-order",
        data() {
            return {};
        },
        created(){
           this.pageName('Your list of Medication')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/prescription/prescription-medicine-order.vue